import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ProfileCropComponent } from 'app/main/pages/profile/tabs/profile-crop/profile-crop.component';
import axios from 'axios';
import { ToastrService } from 'ngx-toastr';
import { GetReportingToService } from '../helper/get-reporting-to';
import { ParseService } from '../parse/parse.service';
import { StorageConfiguration } from '../storage-setting/storage-configuration';
import * as Parse from 'parse';
@Component({
  selector: 'app-add-organization',
  templateUrl: './add-organization.component.html',
  styleUrls: ['./add-organization.component.scss']
})
// export class AddOrganizationComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }

export class AddOrganizationComponent implements OnInit {

  organizationDetailsForm: FormGroup;
  proImage: any;
  imageURL = 'assets/images/avatars/profile.jpg';
  profileCropDialogRef: MatDialogRef<ProfileCropComponent>;
  apiUrl: any;
  organizationId = '';
  empRole = '';
  profileId = '';
  tenantId = '';
  organisationLists = [];
  isEdit = false;

  constructor(
    private parseService: ParseService,
    private formBuilder: FormBuilder,
    private storageConfiguration: StorageConfiguration,
    public dialog: MatDialog,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private getReportingToService: GetReportingToService
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    const emailRegEx = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
    this.organizationDetailsForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(emailRegEx)]],
      // mobile: ['', Validators.required]
    });
  }

  async ngOnInit() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let settings = await query.find();
    this.apiUrl = settings[0].get('apiUrl');
    if (this.data.isEdit == true) {
      this.editOrganization();
    }
  }

  async addOrganization() {
    let queryInstance = this.parseService.instance.Object.extend('Organisation');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('name', this.organizationDetailsForm.value.name);
    let Organisation = await query.find();
    if (Organisation.length > 0) {
      return this.toastr.warning("Already organisation name is available!!")
    }
    else if (this.organizationDetailsForm.valid) {
      let values = this.organizationDetailsForm.value;
      let organizationClass = this.parseService.instance.Object.extend('Organisation');
      var organizationDetails = new organizationClass();
      organizationDetails.set('name', values.name);
      organizationDetails.set('email', values.email);
      organizationDetails.set('mobile', values.mobile);
      organizationDetails.set('organizationImage', this.imageURL);
      organizationDetails.set('data', { name: values.name, email: values.email, mobile: values.mobile });
      organizationDetails.set('isActive', true);
      organizationDetails.set('tenantId', this.tenantId);
      organizationDetails.set('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
      let data = await organizationDetails.save();
      this.toastr.success('Saved successfully.');
      this.dialog.closeAll();
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  async editOrganization() {
    this.isEdit = this.data.isEdit;
    const organizationInstance = this.parseService.instance.Object.extend('Organisation');
    const organizationQuery = new this.parseService.instance.Query(organizationInstance);
    organizationQuery.equalTo('objectId', this.data.id);
    const organizationResults = await organizationQuery.find();
    let data = organizationResults[0];
    this.imageURL = data.get('organizationImage');
    this.organizationDetailsForm.patchValue({
      name: data.get('name'),
      email: data.get('email'),
      mobile: data.get('mobile')
    });
  }

  async updateOrganization() {
    let queryInstance = this.parseService.instance.Object.extend('Organisation');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('name', this.organizationDetailsForm.value.name);
    let Organisation = await query.find();
    if (Organisation.length > 0) {
      return this.toastr.warning("Already organisation name is available!!")
    }
    else if (this.organizationDetailsForm.valid) {
      let values = this.organizationDetailsForm.value;
      const organizationInstance = this.parseService.instance.Object.extend('Organisation');
      const organizationQuery = new this.parseService.instance.Query(organizationInstance);
      organizationQuery.equalTo('objectId', this.data.id);
      const organizationResults = await organizationQuery.find();
      let data = organizationResults[0];
      data.set('name', values.name);
      data.set('email', values.email);
      data.set('mobile', values.mobile);
      data.set('organizationImage', this.imageURL);
      data.set('data', { name: values.name, email: values.email, mobile: values.mobile });
      let res = await data.save();
      this.toastr.success('Updated successfully.');
      this.dialog.closeAll();
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  closepopup() {
    this.dialog.closeAll();
  }

  imageUpload() {
    this.profileCropDialogRef = this.dialog.open(ProfileCropComponent, {
      width: '700px',
    });
    this.profileCropDialogRef.afterClosed().subscribe(result => {
      if (result.status) {
        this.logoUpload(result.file);
      }
    });
  }

  logoUpload(event) {
    var formData = new FormData();
    formData.append("files", event);
    Parse.initialize('erp-twilight');
    Parse.masterKey = ('erp-twilight-master');
    Parse.serverURL = 'https://erp.whatsdare.com/parse';
    const loginResult = Parse.User.logIn('deepa@twilightitsolutions.com', 'SmartWork');
    loginResult.then(res => {
      const myObject = JSON.parse(JSON.stringify(res));
      var session = myObject.sessionToken;
      axios.post(this.apiUrl.mediaPath, formData, {
        headers: {
          "authorization": "Bearer " + session,
          'Content-Type': "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.profileUpdate(res);
      }).catch(err => {
      });
    });
  }

  async profileUpdate(data) {
    var password = this.storageConfiguration.sessionGetItem(this.storageConfiguration.password);
    var email = this.storageConfiguration.sessionGetItem(this.storageConfiguration.email);
    Parse.initialize('erp-g360-eu');
    Parse.masterKey = ('12345678');
    // Parse.serverURL = 'http://sgroups.g360.us/parse';
    Parse.serverURL = 'http://35.180.216.134/parse';

    const loginResult = Parse.User.logIn(email, password);
    loginResult.then(async loginValue => {
      this.imageURL = data.data.url;
      this.toastr.success('Profile uploaded successfully');
    });
  }

  async getOrganisation() {
    await this.getReportingToService.getOrganisation().then(res => {
      this.organisationLists = res;
    });
  }

}

